const AlertIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		fill="currentColor" stroke="none"
		{...props}
	>
		<rect x="6" y="2" width="2" height="6" />
		<rect x="6" y="10" width="2" height="2" />
	</svg>
)

export default AlertIcon